var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSize13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 83,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.817,
    y: 0.176,
    width: 97.862,
    height: 82.245,
    rx: 2,
    fill: "#DFE0E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.132 3.299h30.191v77.04H34.132z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECF0",
    d: "M38.296 6.423h21.863v4.164H38.296zm0 7.287h21.863v4.164H38.296zm0 7.288h21.863v4.164H38.296z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#223143",
    d: "M38.296 28.286h21.863v10.411H38.296z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECECF0",
    d: "M38.296 41.819h21.863v34.356H38.296z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSize13);
export default __webpack_public_path__ + "static/media/size-13.b1b68506e62709ca9ce0b418130b4cdf.svg";
export { ForwardRef as ReactComponent };